export const CHANGE_STATUS_OPEN_MODAL = "CHANGE_STATUS_OPEN_MODAL";
export const CHANGE_STATUS_CLOSE_MODAL = "CHANGE_STATUS_CLOSE_MODAL";
export const CHANGE_STATUS_UPDATE_REQUEST = "CHANGE_STATUS_UPDATE_REQUEST";
export const CHANGE_STATUS_UPDATE_RESULT = "CHANGE_STATUS_UPDATE_RESULT";
export const CHANGE_STATUS_SET_DEVICES = "CHANGE_STATUS_SET_DEVICES";
export const CHANGE_STATUS_CREATE_SCHEDULED_ACTION_REQUEST = "CHANGE_STATUS_CREATE_SCHEDULED_ACTION_REQUEST";
export const CHANGE_STATUS_CREATE_SCHEDULED_ACTION_RESULT = "CHANGE_STATUS_CREATE_SCHEDULED_ACTION_RESULT";
export const CHANGE_STATUS_SEARCH_SCHEDULED_ACTIONS_REQUEST = "CHANGE_STATUS_SEARCH_SCHEDULED_ACTIONS_REQUEST";
export const CHANGE_STATUS_SEARCH_SCHEDULED_ACTIONS_RESULT = "CHANGE_STATUS_SEARCH_SCHEDULED_ACTIONS_RESULT";

